import React from "react";
import { createRoot } from "react-dom/client";
import Popup from "../components/ui/Popup";

let currentRoot = null;
let currentContainer = null;

export function showPopup({ title, titleIcon, content, actions }) {
  // Clean up existing popup if it exists
  if (currentRoot) {
    currentRoot.unmount();
    currentContainer.remove();
  }

  // Create new container and root
  const containerElement = document.createElement("div");
  document.body.appendChild(containerElement);
  
  currentContainer = containerElement;
  currentRoot = createRoot(containerElement);

  const closePopup = () => {
    if (currentRoot) {
      currentRoot.unmount();
      currentContainer.remove();
      currentRoot = null;
      currentContainer = null;
    }
  };

  const actionsWithClose =
    typeof actions === "function"
      ? actions(closePopup)
      : React.cloneElement(actions, { closePopup });

  currentRoot.render(
    <Popup
      open={true}
      onClose={closePopup}
      title={title}
      titleIcon={titleIcon}
      content={content}
      actions={actionsWithClose}
    />
  );

  return closePopup;
}
